module.exports = __webpack_public_path__ + "bg.13b8ea647f91cb3ee8d6.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles